import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of, throwError } from 'rxjs';
import { Form } from '../../domain/form.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  constructor(private api: ApiService) {}

  getVersions(formId: string): Observable<any[]> {
    console.log('Get Versions')    
    return this.api.get(`/forms/${formId}/versions`);
  }
  getVersion(formId: string, version: Form): Observable<{ content: Form }> {
    return this.api.get(`/forms/${formId}/versions/${version.sk}`);
  }

  addVersion(formId: string): Observable<{ content: Form }> {  
    //const error = new HttpErrorResponse({ status: 500, error: "Testing error" });
    //return throwError(() => error)
    console.log('ADDD VERSION SERVICE')
    return this.api.post(`/forms/${formId}/versions`, {});
  }

  editVersion(formId: string, version: Form): Observable<{ content: Form }> {
    return this.api.put(`/forms/${formId}/versions/${version.sk}`, version);
  }

  deleteVersion(formId: string, version: Form): Observable<{ content: { form: Form } }> {
    console.log('Delete Version')
    return this.api.delete(`/forms/${formId}/versions/${version.sk}`, version);
  }

}
